//  Image = 1,
//   Matterport = 2,
//   Video = 3,
export type FileItemFileType = 1 | 2 | 3;

export class FileItemFileTyped {
  static Image = 1;
  static Matterport = 2;
  static Video = 3;
}
